import React, { useState, useRef } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem2xs4,
    GridItem10xs8,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    IconButtonAIFT,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    SvgImageAIFT,
} from '../../../business-components/SvgImage/SvgImage'

import {
    calculaExibeAIFT,
    calculaAnaliseInformacoes,
} from './AIFTService'



const AnalisesInformacoesAIFT = ({ aiFTOrigem, variaveisGlobais, values, estudo, vars, report, dadosAIFT, estudoAIFT, estudoAIFT2 }) => {

    const GridItemAnalisesInformacoesAIFT = report ? GridItem12 : GridItem10xs8

    return (
        <GridContainer>
            <GridItemAnalisesInformacoesAIFT>
                <div
                    className='mt-15'
                >
                    {calculaAnaliseInformacoes(aiFTOrigem, variaveisGlobais, values, estudo, vars, report,
                        dadosAIFT, estudoAIFT, estudoAIFT2)}
                </div>
            </GridItemAnalisesInformacoesAIFT>

            {!report && (
                <GridItem2xs4>
                    <SvgImageAIFT
                        fontSize="large"
                    />
                </GridItem2xs4>
            )}
            
        </GridContainer>
    )
}

export const AIFT = ({ aiFTOrigem, variaveisGlobais, values, estudo, vars, report }) => {

    const dadosAIFT = useRef(null)
    const estudoAIFT = useRef(null)
    const estudoAIFT2 = useRef(null)

    const [exibeAIFT, setExibeAIFT] = useState(false)

    useSingleton(() => {

        dadosAIFT.current = {}

        setExibeAIFT(calculaExibeAIFT(aiFTOrigem, values, estudo, dadosAIFT))
    })



    return (
        exibeAIFT
            ?
                report
                    ?
                        <AnalisesInformacoesAIFT
                            aiFTOrigem={aiFTOrigem}
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            estudo={estudo}
                            vars={vars}
                            report={report}
                            dadosAIFT={dadosAIFT}
                            estudoAIFT={estudoAIFT}
                            estudoAIFT2={estudoAIFT2}
                        />
                    :
                        <CustomizedDialogsPopup
                            maxWidth='lg'
                            popupTitle={LABEL.aiFTHTML}
                            tooltipTitle={LABEL.aiFT}
                            PopupButton={IconButtonAIFT}
                            bgDefault={false}
                            popupComponent={ 
                                <AnalisesInformacoesAIFT
                                    aiFTOrigem={aiFTOrigem}
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    estudo={estudo}
                                    vars={vars}
                                    dadosAIFT={dadosAIFT}
                                    estudoAIFT={estudoAIFT}
                                    estudoAIFT2={estudoAIFT2}
                                />
                            }
                        />
            :
                ''
    )
}